var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import styled from "styled-components";
import { colors } from "../../../styles/colors";
const ButtonWrapper = styled.div `
  margin-top: 15px;
  padding: 2px;

  border-radius: 8px;
  background: linear-gradient(135deg, ${colors.primaryLight} 0%, ${colors.primaryDark} 100%);
`;
const Button = styled.button `
  justify-content: center;
  align-items: center;
  padding: 16px 0;
  width: 100%;

  text-transform: uppercase;
  color: ${colors.textPrimary};
  font-weight: 800;
  font-family: 'Inter';
  text-shadow: 0px 1px 2px rgba(0, 0, 0, 0.5);

  border: none;
  border-radius: 6px;
  background: linear-gradient(135deg, ${colors.primary} 0%, ${colors.primaryDark} 100%);
  transition: all 0.2s;

  cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
  opacity: ${props => props.disabled ? 0.5 : 1};
  pointer-events: ${props => props.disabled ? 'none' : 'auto'};

  &:hover:not(:disabled) {
    background: linear-gradient(135deg, ${colors.primaryLight} 0%, ${colors.primary} 100%);
  }
`;
export const PrimaryButton = (_a) => {
    var { onClick, disabled, text } = _a, rest = __rest(_a, ["onClick", "disabled", "text"]);
    return (_jsx(ButtonWrapper, { children: _jsx(Button, Object.assign({ onClick: onClick, disabled: disabled }, rest, { children: text })) }));
};
